/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class HolidayModalModel {
        public dateOpened:boolean;

        constructor(private holidayService:warsApp.services.HolidaySetService) {
            
        }
        public open() {
            this.dateOpened = true;
        }
    }
}